
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { BoardCategory } from '@/types/board';
import { useAuth } from '@/hooks/useAuth';
import { SEO } from '@/components/seo/SEO';
import { BoardWriteHeader } from '@/components/board/BoardWriteHeader';
import { BoardWriteForm } from '@/components/board/BoardWriteForm';

const WritePost = () => {
  const { user, loading, initialized } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [searchParams] = useSearchParams();
  const categoryParam = searchParams.get('category') as BoardCategory;
  
  // Redirect to login if not authenticated - but only after auth loading is complete
  useEffect(() => {
    // Only redirect if we're sure the user is not logged in (loading is complete and initialized)
    if (!loading && initialized && !user) {
      toast({
        variant: "destructive",
        title: "로그인이 필요합니다",
        description: "게시글을 작성하려면 로그인해주세요."
      });
      navigate('/login', { replace: true });
    }
  }, [user, loading, initialized, navigate, toast]);

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 container mx-auto py-8 px-4 flex items-center justify-center">
          <p>로딩 중...</p>
        </main>
        <Footer />
      </div>
    );
  }

  // Render the form (whether authenticated or not - redirect happens via useEffect)
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <SEO title={`${categoryParam || '자유게시판'} 글쓰기`} description="새로운 게시글을 작성하세요" />
      
      <main className="flex-1 container mx-auto py-8 px-4">
        <div className="mb-6">
          <BoardWriteHeader title="게시글 작성" />
          <BoardWriteForm initialCategory={categoryParam} user={user} />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default WritePost;
